import * as types from './actionTypes';
import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';

export function isFavouriteSuccess(favourited) {
  return { type: types.LOAD_FAVOURITE_SUCCESS, favourited };
}

export function addFavouriteSuccess() {
  return { type: types.ADD_FAVOURITE_SUCCESS };
}

export function removeFavouriteSuccess() {
  return { type: types.REMOVE_FAVOURITE_SUCCESS };
}

export function isFavourite(modelId, modelType) {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/is-favourite?content_id=${modelId}&model_type=${modelType}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => {
      response.json().then((content) => {
        dispatch(isFavouriteSuccess(content.data));
      });
    }).catch((error) => {
      throw (error);
    });
  };
}

export function addFavourite(modelId, modelType) {
  const item = {};
  item.model_id = modelId;
  item.model_type = modelType;

  return function(dispatch) {
    // Optmistic UI pattern
    dispatch(addFavouriteSuccess());

    return fetch(`${getAPIPath}commandapi/favourite`, {
      method: 'POST',
      body: JSON.stringify(item),
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    }).then((response) => {
      if (response.status !== 200) {
        dispatch(removeFavouriteSuccess());
        dispatch(addNotification({
          message: 'There was a problem favouriting this content. Please contact us if the problem persists.',
          level: 'error',
          autoDismiss: 0,
        }));
      }
    }).catch((error) => {
      throw (error);
    });
  };
}

export function removeFavourite(modelId, modelType) {
  return function(dispatch) {
    // Optmistic UI pattern
    dispatch(removeFavouriteSuccess());

    return fetch(`${getAPIPath}queryapi/favourite?model_id=${modelId}&model_type=${modelType}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    }).then((response) => {
      if (response.status !== 200) {
        dispatch(addFavouriteSuccess());
        dispatch(addNotification({
          message: 'There was a problem unfavouriting this content. Please contact us if the problem persists.',
          level: 'error',
          autoDismiss: 0,
        }));
      }
    }).catch((error) => {
      throw (error);
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/favouriteActions.js